import { render, staticRenderFns } from "./InvoiceStatusBadge.vue?vue&type=template&id=586136e3&"
import script from "./InvoiceStatusBadge.vue?vue&type=script&lang=js&"
export * from "./InvoiceStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports